module.exports = __webpack_public_path__ + "static/media/pause.a591fdfc.svg";